var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDlr(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 19,
    viewBox: "0 0 15 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14 4H2C1.63573 4 1.29419 3.90262 1 3.73246V17C1 17.5525 1.44775 18 2 18H14V4ZM14.8536 3.14645C14.944 3.23693 15 3.36193 15 3.5V18.5C15 18.7761 14.7761 19 14.5 19H2C0.895564 19 0 18.1048 0 17V2C0 0.895151 0.895564 0 2 0H13.5C13.7761 0 14 0.223858 14 0.5V3H14.5C14.6381 3 14.7631 3.05596 14.8536 3.14645ZM10.2929 13L7.5 10.2071L5.85355 11.8536C5.65829 12.0488 5.34171 12.0488 5.14645 11.8536L3.14645 9.85355C2.95118 9.65829 2.95118 9.34171 3.14645 9.14645C3.34171 8.95118 3.65829 8.95118 3.85355 9.14645L5.5 10.7929L7.14645 9.14645C7.34171 8.95118 7.65829 8.95118 7.85355 9.14645L11 12.2929V10.5C11 10.2239 11.2239 10 11.5 10C11.7761 10 12 10.2239 12 10.5V13.5C12 13.7761 11.7761 14 11.5 14H8.5C8.22386 14 8 13.7761 8 13.5C8 13.2239 8.22386 13 8.5 13H10.2929ZM13 3V1H2C1.44775 1 1 1.44754 1 2C1 2.55246 1.44775 3 2 3H13Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDlr);
export default __webpack_public_path__ + "static/media/dlr.933f0e9ad42a5ce91122caf17394f54f.svg";
export { ForwardRef as ReactComponent };